import { _ } from "../polyglot/polyglot.js";
import { htmlCanvas, Widget } from "@foretagsplatsen/widgetjs";
import { iconAndText } from "../elements/index.js";
import { lockIcon } from "../elements/icons/index.js";

/**
 * `MarketingPopupWidget` is a widget that visually blocks off a feature when
 * the user is using the freemium version of the app.
 *
 * It displays a popup over a blurry transparent overlay.
 */
export default class MarketingPopupWidget extends Widget {
	show(documentTitle) {
		this._documentTitle = documentTitle;
		this._show();
	}

	kill() {
		this._removeModalFromDocument();
	}

	renderContentOn(html) {
		html.div(
			{
				class: "modal-dialog marketing-modal",
				"data-test": "marketing",
			},
			html.div(
				{ class: "modal-content" },
				html.div(
					{ class: "modal-header" },
					this._renderTitleOn.bind(this),
				),
				html.div(
					{ class: "modal-body" },
					this._renderBodyOn.bind(this),
				),
			),
		);

		this.asJQuery().on(
			"hidden.bs.modal",
			this._removeModalFromDocument.bind(this),
		);
	}

	_renderTitleOn(html) {
		html.h3(
			{
				class: "modal-title",
			},
			iconAndText(
				lockIcon,
				_("{featureName} is a premium feature", {
					featureName: (html) => html.render(this._documentTitle),
				}),
			),
		);
	}

	_renderBodyOn(html) {
		html.div(_("To unlock this feature, please contact your consultant."));
	}

	_show() {
		this._removeModalFromDocument();
		this.renderOn(htmlCanvas("body"));
		this.asJQuery().modal({ backdrop: false });
	}

	_willDetach() {
		this._removeModalFromDocument();
	}

	_removeModalFromDocument() {
		if (!this.isRendered()) {
			return;
		}
		this.asJQuery().modal("hide").remove();
	}
}
